<script setup lang="ts">
import MainHeader from "./Header/index.vue";
import MainFooter from "./Footer/index.vue";
import ModalSubscribePlans from "@/components/Modais/ModalSubscribePlansAndCredits.vue";
import ModalMessages from "@/components/Modais/ModalMessages.vue";
import ModalSubscribeExit from "@/components/Modais/ModalSubscribeExit.vue";
import ModalSubscribeExitEmail from "@/components/Modais/ModalSubscribeExitEmail.vue";
import ModalPromotionPopup from "@/components/Modais/ModalPromotionPopup.vue";
import ModalPromotionPopupEmail from "@/components/Modais/ModalPromotionPopupEmail.vue";
import ModalAcceptCookies from "@/components/Modais/ModalAcceptCookies.vue";
import ModalNewsletter from "@/components/Modais/ModalNewsletter.vue";
import MetaTags from "./MetaTags.vue";
import ModalLegalWarning from "@/components/Modais/ModalLegalWarning.vue";
import ModalNotification from "@/components/Modais/ModalNotification.vue";
import ModalBannerPlanUnique from "@/components/Modais/ModalBannerPlanUnique.vue";
import IconeBds from "assets/img/icone_BDS.png";

import api from "@/api";
import { detectIncognito } from "detectincognitojs";
import { useCookies } from "vue3-cookies";
import { usePromotionAudience } from "@/composables/usePromotionAudience";
import { marcarSinoRemovido, sinoFoiRemovido } from "@/utils/sinoDeNotificacao";
import ModalPopupFreetour from "@/components/Modais/ModalPopupFreetour.vue";
import ModalPopupUpgrade from "@/components/Modais/ModalPopupUpgrade.vue";
import ModalPopupInvite from "@/components/Modais/ModalPopupInvite.vue";
import ModalPopupCredit from "@/components/Modais/ModalPopupCredit.vue";
import ModalPopupCoupon from "@/components/Modais/ModalPopupCoupon.vue";

const { cookies } = useCookies();
const { canSeePromotion } = usePromotionAudience();
const storePlan = planStore();
const storeUser = userStore();
const storePlanCredit = planCreditStore();
const storeSubscribeExit = subscribeExitStore();
const storeNotification = notificationStore();
// Arbitro unico dos modais — ver stores/modalArbiter.ts. Substitui as listas de
// document.getElementById que estavam copiadas a mao em 9 blocos.
const arbitro = modalArbiterStore();
const route = useRoute();

const optionsPlanUnique = ref({
  showFooter: false,
  image: "",
});

const isOpenMenu = ref(false);
const showSubscribe = ref(false);
const options = ref({
  showModal: false,
  titleModal: "",
  textBodyModal: "",
  textButtonModal: "",
  routerName: "",
  presente: false,
});
const optionsSubsExit = ref({
  showModal: false,
  html: "",
  link: "",
});
const optionsSubsExitEmail = ref({
  showModal: false,
  subscribeExitId: 0,
  image: "",
  html: "",
  inputs: { email_placeholder: "" },
  cta: { label: "" },
  locale: "pt-br",
});
const promotions = ref<any[]>([]);
const newsletter = ref({});
const showModalCookies = ref(false);
const optionsNotifications = ref({
  showModal1: false,
  showModal2: false,
  showModal3: false,
  showBell: false,
});

const reactiveLocale = computed(() => route.params.language);
const reactiveisActiveUser = computed(() => storeUser.isActiveUser);
const reactiveVoucher = computed(() => storePlan.voucher);
const reactiveCoupon = computed(() => storePlan.coupon);
const reactiveisLoggedIn = computed(() => storeUser.isLoggedIn);
const optionsModalFreetour = ref({
  videoPath: "",
  videoTime: 0,
});

watch(reactiveVoucher, () => {
  storePlan.setCloseBanner(false);
  getBannerPlanUnique();
});

watch(reactiveisLoggedIn, () => {
  getPlansType();
});

onBeforeMount(() => {
  if (
    reactiveLocale.value !== storePlan.languagePlans ||
    route.query.coupon ||
    route.query.voucher ||
    !storePlan.plans ||
    !storePlan.plansType.length ||
    route.query.code_share
  ) {
    getPlansType();
  }
  registerSubscribeExitLocalStorage();
  const isOffPromoRoutes =
    route.name != "language-assine" &&
    route.name != "language-assine-period" &&
    route.name != "language-assine-turbo" &&
    route.name != "language-assine-account" &&
    route.name != "language-assine-checkout" &&
    route.name != "language-assine-checkout-success" &&
    route.name != "language-login";
  if (isOffPromoRoutes) {
    // Sempre busca os promotion popups: o público-alvo (targetAudience) de
    // cada popup é verificado na exibição, podendo incluir usuários ativos.
    getModalsPromotionPopup();
  }
  if (storeUser.isActiveUser == false && isOffPromoRoutes) {
    getModalSubscribeExit(false)
    getModalNewsletter();
  }

  if (
    reactiveLocale.value !== storePlanCredit.languagePlansCredits ||
    !storePlanCredit.plansCredits ||
    reactiveVoucher.value ||
    route.query.coupon
  )
    getPlansCredits();
  storeUser.getActiveUser();

});


onMounted(() => {
  getAffiliates();
  setInterval(() => {
    if (
      document.getElementById("modalLegalWarning") == null &&
      route.name != "language-assine" &&
      route.name != "language-assine-period" &&
      route.name != "language-assine-turbo" &&
      route.name != "language-assine-account" &&
      route.name != "language-assine-checkout"
    ) {
      showModalCookies.value = true;
    }
  }, 5000);
  setTimeout(() => {
    userNotification();
  }, 100);
  getBannerPlanUnique();

  if (storeUser.isLoggedIn) eventGTMUserID();

  if (route.name == "language-freetour") {
    getModalPopupFreetour();
  }

});

async function getModalPopupFreetour() {
  api
    .get(`v1/home/getModalPopupFreetour?locale=${reactiveLocale.value ?? ""}`)
    .then(({ data }) => {
      optionsModalFreetour.value.videoPath = data.videoPath;
      optionsModalFreetour.value.videoTime = data.videoTime;
    });
}

function getAffiliates() {
  let paramUrl =
    route.params.locale != "pt-br" && route.params.locale != "en"
      ? route.params.locale
      : "";
  if (route.query.cp || route.query.partner || paramUrl) {
    api
      .get("v1/checkAffiliates", { params: { url: paramUrl, ...route.query } })
      .then(({ data: { redirect } }) => {
        if (redirect) window.location.replace(redirect);
      });
  }
}

function getPlansCredits() {
  api
    .get(
      `v1/home/getPlansCredits?language=${reactiveLocale.value ?? ""}&coupon=${
        route.query.coupon || reactiveCoupon.value || ""
      }`
    )
    .then(({ data }) => {
      storePlanCredit.setPlanCredits(data.plans);
    });
}

async function getModalsPromotionPopup() {
  api
    .get(
      `v1/promotions/getActivePromotions?locale=${reactiveLocale.value ?? ""}`
    )
    .then(({ data }) => {
      if (data.length) {
        promotions.value = data;
        if (!cookies.isKey("bellaPromoShow")) {
          cookies.set("bellaPromoShow", "1", 1000 * 60 * 60 * 24);
        }
        if (!cookies.isKey("countAccessPromotion")) {
          cookies.set("countAccessPromotion", "0", 1000 * 60 * 60 * 24 * 7);
        }
      } else {
        cookies.remove("bellaPromoShow");
        cookies.remove("countAccessPromotion");
        cookies.remove("showFooterPromoBanner");
      }
    });
}

async function getModalNewsletter() {
  api.get(`v1/newsletter/getActiveNewsletterApi`).then(({ data }) => {
    newsletter.value = data;
  });
}

async function getModalSubscribeExit(forceShowModal: any) {
  var params = storeSubscribeExit.bellaSubscribeExit;
  if (params.count) {
    let requestOptions = {
      first_date:
        params.first_time_date.year +
        "-" +
        params.first_time_date.month +
        "-" +
        params.first_time_date.day,
      count: params.count,
      has_showed: params.has_showed,
      language: reactiveLocale.value,
      newfront: true,
    };
    api.post("modal/show/exit-subscribe", requestOptions).then(({ data }) => {
      if (typeof data === "object") {
        data.canShowModal = forceShowModal || data.canShowModal || false;
        let canShowModal = data.canShowModal;
        // mostra o modal se regra foi atendida e se ainda não foi mostrado E se não estiver na página do assine
        if (
          canShowModal &&
          params.has_showed === "false" &&
          (params.last_page !== route.name || forceShowModal)
        ) {
          // O tipo decide qual id e reservado; por isso vem antes da reserva.
          const isEmail = data.type === "email";

          if (
            arbitro.tryOpen(isEmail ? "modalSubscribeExitEmail" : "modalSubscribeExit")
          ) {

            if (isEmail) {
              const campaignId = data.subscribe_exit_id;
              if (storeSubscribeExit.hasSubmittedForCampaign(campaignId)) {
                return;
              }
              optionsSubsExitEmail.value = {
                showModal: true,
                subscribeExitId: campaignId,
                image: data.modal?.image ?? "",
                html: data.modal?.html ?? "",
                inputs: {
                  email_placeholder: data.modal?.inputs?.email_placeholder ?? "",
                },
                cta: {
                  label: data.modal?.cta?.label ?? "",
                  bg_color: data.modal?.cta?.bg_color,
                  text_color: data.modal?.cta?.text_color,
                },
                locale: reactiveLocale.value === "en" ? "en" : "pt-br",
              };
            } else {
              var html = (data.html ?? "").replace(/#close-modal-promo/g, "");
              optionsSubsExit.value.html = html;
              optionsSubsExit.value.link = data.urlLink;
              optionsSubsExit.value.showModal = true;
            }

            params.has_showed = "true";
            storeSubscribeExit.setSubscribeParams(params);

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "view_promotion",
              ecommerce: {
                promotion_name: "Saída do Assine",
              },
            });
          }
        }
      }
    });
  }
}

function registerSubscribeExitLocalStorage() {
  if (typeof localStorage === "object" && route.name == "language-assine") {
    var params: any = {};
    if (!storeSubscribeExit.bellaSubscribeExit.count) {
      params = {
        last_page: route.name,
        first_time_date: getJsonDate(),
        count: 1,
        has_showed: "false",
      };
    } else {
      // incrementa a contagem
      params = storeSubscribeExit.bellaSubscribeExit;
      params.count++;
      params.has_showed = "false";
    }
    storeSubscribeExit.setSubscribeParams(params);
  }
}
function getJsonDate() {
  var dateObj = new Date();
  var month = dateObj.getUTCMonth() + 1; //months from 1-12
  var day = dateObj.getUTCDate();
  var year = dateObj.getUTCFullYear();
  return {
    day: day,
    month: month,
    year: year,
  };
}
async function getBannerPlanUnique() {
  if (
    reactiveVoucher.value != "" &&
    storePlan.closeBannerPlanUnique == false &&
    reactiveisActiveUser.value == false
  ) {
    api
      .get(
        `v1/promotions/getBannerPlanUnique?locale=${reactiveLocale.value ?? ""}`
      )
      .then(({ data }) => {
        if (data != "") {
          if (
            route.name != "language-assine" &&
            route.name != "language-assine-account" &&
            route.name != "language-assine-period" &&
            route.name != "language-assine-turbo" &&
            route.name != "language-assine-checkout" &&
            arbitro.tryOpen("modalBannerPlanUnique")
          ) {
            optionsPlanUnique.value.showFooter = true;
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "view_promotion",
              ecommerce: {
                promotion_name: "banner rodapé plano único",
              },
            });
          }
          optionsPlanUnique.value.image = data;
        }
      });
  }
}

// Busca/ordenação/seed dos planos agora vivem em composables/usePlansType.ts
// (compartilhado com o SSR da página /assine). Aqui mantemos o mesmo disparo
// client-side (onBeforeMount + watch), fire-and-forget como antes.
function getPlansType() {
  return fetchAndSeedPlansType(resolvePlansTypeParams());
}
function closeNotification() {
  arbitro.close("modalNotification");
  optionsNotifications.value.showModal1 = false;
}
function closeNotificationCheckBar() {
  optionsNotifications.value.showModal2 = false;
}
function subscribeShowPrompt() {
  closeNotification();
  Notification.requestPermission().then((permission) => {
    if (permission === "granted") {
      addServiceWorkerAndRegister(true);
      optionsNotifications.value.showModal2 = false;
    }
  });
  setTimeout(() => {
    if (Notification.permission == "default" && !detectmob()) {
      optionsNotifications.value.showModal2 = true;
    }
  }, 2000);
}

async function userNotification() {
  if (
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  ) {
    let paramsNotification: any = new Object();
    if (!storeNotification.bellaNotifications.timer_show) {
      paramsNotification.first_time_date = new Date().getTime();
      paramsNotification.first_show = false;
      await api.get("v1/notifications/getParameters").then(({ data }) => {
        paramsNotification.timer_show = data.notification_timer_show;
        paramsNotification.days_next = data.notification_days_next;
        paramsNotification.wp_key = data.notification_webpush_key;
      });
      storeNotification.setNotificationsParams(paramsNotification);
    } else {
      paramsNotification = storeNotification.bellaNotifications;
    }
    if (Notification.permission == "default") {
      if (
        paramsNotification.first_show == false &&
        typeof paramsNotification.timer_show === "string"
      ) {
        setTimeout(() => {
          showModalNotification();
          paramsNotification.first_show = true;
          paramsNotification.first_time_date = new Date().getTime();
          storeNotification.setNotificationsParams(paramsNotification);
        }, parseInt(paramsNotification.timer_show) * 1000);
      } else {
        const daysNext =
          parseInt(paramsNotification.days_next) * 24 * 60 * 60 * 1000;

        const diffNowFirst =
          new Date().getTime() - +paramsNotification.first_time_date;
        if (diffNowFirst > daysNext) {
          setTimeout(() => {
            showModalNotification();
            paramsNotification.first_time_date = new Date().getTime();
            storeNotification.setNotificationsParams(paramsNotification);
          }, parseInt(paramsNotification.timer_show) * 1000);
        }
      }
    } else if (Notification.permission == "granted") {
      addServiceWorkerAndRegister(false);
      storeNotification.resetNotificationsParams();
    } else if (Notification.permission == "denied") {
      storeNotification.resetNotificationsParams();
    }
  }
  detectIncognito().then((result) => {
    if (
      Notification.permission != "granted" &&
      result.isPrivate == false &&
      !sinoFoiRemovido(localStorage) &&
      (window.location.protocol == "https:" ||
        window.location.hostname == "localhost")
    ) {
      optionsNotifications.value.showBell = true;
    }
  });
}
function showModalNotification() {
  detectIncognito().then((result) => {
    if (
      Notification.permission == "default" &&
      result.isPrivate == false &&
      (window.location.protocol == "https:" ||
        window.location.hostname == "localhost")
    ) {
      if (
        arbitro.tryOpen("modalNotification")
      ) {
        //Modal Newsletter
        optionsNotifications.value.showModal1 = true;
      }
    }
  });
}

function addServiceWorkerAndRegister(showWelcome: boolean) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    if (registrations.length == 0) {
      navigator.serviceWorker.register("/service-worker.js", { scope: "/" });
      subscribeRegister(showWelcome);
    } else {
      navigator.serviceWorker.ready.then((sw) => {
        sw.pushManager.getSubscription().then((subscription) => {
          if (subscription == null) {
            subscribeRegister(showWelcome);
          }
        });
      });
    }
  });
}
function subscribeRegister(showWelcome: boolean) {
  const paramsNotification = storeNotification.bellaNotifications;
  navigator.serviceWorker.ready.then((sw) => {
    sw.pushManager
      .subscribe({
        userVisibleOnly: true,
        applicationServerKey: atob(paramsNotification.wp_key),
      })
      .then((subscription) => {
        optionsNotifications.value.showBell = false;
        const requestOptions = {
          data: JSON.stringify(subscription),
          locale: reactiveLocale.value ?? "pt-br",
        };
        api
          .post("v1/notifications/savePushSubscriptionApi", requestOptions)
          .then(({ data }) => {
            cookies.set(
              "subscriptionId",
              data["subscriptionId"],
              1000 * 60 * 60 * 24 * 365
            );
            storeNotification.resetNotificationsParams();
            closeNotification();
            if (showWelcome) sendNotificationWelcome();
          });
      });
  });
}
function sendNotificationWelcome() {
  if (reactiveLocale.value == "en") {
    var notify_title = "Welcome";
    var notify_body =
      "From now on, you'll stay up to date with all the news from Bella Club, through this notification window!";
  } else {
    var notify_title = "Seja bem-vindo";
    var notify_body =
      "A partir de agora, você vai ficar por dentro de todas as novidades do Bella da Semana, através desta janela de notificações!";
  }
  navigator.serviceWorker.ready.then((registration) => {
    registration.showNotification(notify_title, {
      tag: "tag-welcome",
      body: notify_body,
      icon: IconeBds,
      badge: IconeBds,
      requireInteraction: true,
    });
  });
}
function checkNotificationStatus() {
  if (Notification.permission == "default") {
    optionsNotifications.value.showModal1 = true;
  } else {
    optionsNotifications.value.showModal3 = true;
  }
}
function closeNotificationStatus() {
  optionsNotifications.value.showModal3 = false;
}
function removeBell() {
  optionsNotifications.value.showBell = false;
  marcarSinoRemovido(localStorage);
}
function detectmob() {
  return !!(
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i)
  );
}

function showModalSubscribeExit(data: { message: { show: boolean } }) {
  if (!data.message.show) {
    arbitro.close("modalSubscribeExit");
  }
  optionsSubsExit.value.showModal = data.message.show;
}

function closeModalSubscribeExitEmail() {
  arbitro.close("modalSubscribeExitEmail");
  optionsSubsExitEmail.value.showModal = false;
}
function showMenuLateral(value: boolean) {
  isOpenMenu.value = value;
}
function showModalSubscribePlans(val: boolean) {
  showSubscribe.value = val;
}
function handleContextMenu(event: Event) {
  if (route.path.includes("video") || route.path.includes("making-of"))
    event.preventDefault();
}
function showModalMessages(data: {
  message: {
    show: boolean;
    title: string;
    textBoby: string;
    textButton: string;
    routerName: string;
    presente: boolean;
  };
}) {
  options.value.showModal = data.message.show;
  options.value.titleModal = data.message.title;
  options.value.textBodyModal = data.message.textBoby;
  options.value.textButtonModal = data.message.textButton;
  options.value.routerName = data.message.routerName;
  options.value.presente = data.message.presente;
}

// Só o id interno: tudo o que entra no dataLayer fica visível para todas as tags
// do GTM (GA4, Meta, Ads), e e-mail ali é dado pessoal.
function eventGTMUserID() {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "user_id",
    user_id: {
      id: storeUser.user.id,
      plano: storeUser.isActiveUser ? "ativo" : "sem plano",
    },
  });
}

</script>
<template>
  <MetaTags />
  <div class="custom-container" @contextmenu="handleContextMenu">
    <MainHeader
      :show="isOpenMenu"
      @showMenuLateral="showMenuLateral"
      @showModalSubscribePlans="showModalSubscribePlans"
    />

    <main style="min-height: calc(100dvh - 65px); background-color: #FFFFFF;">
      <slot :showModalMessages="showModalMessages" />
    </main>
    <ModalLegalWarning />
    <ModalMessages @showModalMessages="showModalMessages" :options="options" />
    <MainFooter v-if="true" @showModalMessages="showModalMessages" />
    <ModalSubscribePlans
      @showModalSubscribePlans="showModalSubscribePlans"
      :showSubscribe="showSubscribe"
      v-if="storePlan.plans"
      :plans="storePlan.plans"
    />
    <ModalSubscribeExit
      :optionsSubsExit="optionsSubsExit"
      @showModalSubscribeExit="showModalSubscribeExit"
    />
    <ModalSubscribeExitEmail
      :options="optionsSubsExitEmail"
      @close="closeModalSubscribeExitEmail"
    />
    <template v-for="(promotion, index) in promotions" :key="index">
      <template v-if="promotion && canSeePromotion(promotion)">
        <ModalPromotionPopupEmail
          v-if="promotion.type === 'email'"
          :optionsPromotionPopup="promotion"
        />
        <ModalPromotionPopup
          v-else
          :optionsPromotionPopup="promotion"
        />
      </template>
    </template>
    <ModalNewsletter
      v-if="newsletter"
      :optionsNewsletter="newsletter"
      @showModalMessages="showModalMessages"
    />
    <ModalAcceptCookies v-if="showModalCookies" />
    <ModalNotification
      :optionsNotifications="optionsNotifications"
      @closeNotification="closeNotification"
      @subscribeShowPrompt="subscribeShowPrompt"
      @closeNotificationCheckBar="closeNotificationCheckBar"
      @checkNotificationStatus="checkNotificationStatus"
      @closeNotificationStatus="closeNotificationStatus"
      @removeBell="removeBell"
    />
    <ModalBannerPlanUnique :optionsPlanUnique="optionsPlanUnique" />
    <ModalPopupFreetour :optionsModalFreetour="optionsModalFreetour" />
    <ModalPopupUpgrade />
    <ModalPopupInvite />
    <ModalPopupCredit />
    <ModalPopupCoupon />
  </div>
</template>

<!-- .custom-container, .right-menu e .show-menu: compartilhados com o layout
     afiliado.vue (ver o comentário no arquivo). -->
<style src="../assets/css/moldura-site.css"></style>

<style>
#slot-post-api img {
  max-width: 100% !important;
}

#slot-post-api a {
  text-decoration: underline;
}

.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.cursor-pointer {
  cursor: pointer;
}

.pagination-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 10px;
}

.paginate-buttons {
  height: 40px;
  width: 40px;
  border-radius: 20px;
  cursor: pointer;
  background-color: rgb(242, 242, 242);
  border: 1px solid rgb(217, 217, 217);
  color: black;
}

.paginate-buttons:hover {
  background-color: #d8d8d8;
}

.active-page {
  background-color: #b20000;
  border: 1px solid #b20000;
  color: white;
}

.active-page:hover {
  background-color: #b20000;
}

ul#componentContainer {
  display: flex !important;
  justify-content: center;
}

.l-header {
  position: sticky;
}

</style>
